import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { PricingProvider } from "@/contexts/PricingContext";
import LandingPage from "@/pages/LandingPage";
import CreateWizard from "@/pages/CreateWizard";
import StoryOutput from "@/pages/StoryOutput";
import "@/App.css";

function App() {
  return (
    <PricingProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/create" element={<CreateWizard />} />
          <Route path="/story" element={<StoryOutput />} />
          <Route path="/story/:storyId" element={<StoryOutput />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </PricingProvider>
  );
}

export default App;
